import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Heading, Logo, Spacing, useTheme } from "@huub-web/ui";

export const LogoHubHeading: FC = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <>
      <Spacing height="m" />
      <Logo theme={theme} size="xl" />
      <Spacing height="m" />
      <Heading
        variant="main"
        title={t("hubHeading.title")}
        description={t("hubHeading.description")}
      />
    </>
  );
};
